import { IconQR, IconCar, IconBell, IconUsers } from './icons';

const SESSIONS = [
  {
    id: 'S-4821',
    spot: 'Bay A-01',
    status: 'ordering',
    items: ['Smash burger ×1', 'Large fries ×1', 'Iced lemonade ×2'],
    total: 'PKR 1,840',
  },
  {
    id: 'S-4822',
    spot: 'Counter B-03',
    status: 'new',
    items: ['Crispy chicken ×2', 'Coleslaw ×1'],
    total: 'PKR 1,200',
  },
  {
    id: 'S-4823',
    spot: 'Drive-Thru C',
    status: 'ready',
    items: ['Veggie wrap ×1', 'Fresh juice ×1', 'Brownie ×2'],
    total: 'PKR 2,050',
  },
];

const CAPS = [
  {
    icon: <IconQR />,
    title: 'Zero shared carts',
    body: 'Every scan opens a private session. No crossed orders, no confusion — just your cart.',
  },
  {
    icon: <IconCar />,
    title: 'Any surface',
    body: 'Dashboard sticker, counter card, or drive-through kiosk — one platform handles all.',
  },
  {
    icon: <IconBell />,
    title: 'Instant session',
    body: 'Scan once. Browse immediately. No login, no app download, no waiting.',
  },
  {
    icon: <IconUsers />,
    title: 'Unlimited concurrency',
    body: 'Every bay active at once. Sessions are fully independent at any scale.',
  },
];

export default function CarOrdering() {
  return (
    <section className="carordering" id="car-ordering">

      {/* Header */}
      <div className="car-header">
        <div className="car-header-l">
          <div className="kicker reveal">
            <span className="kicker-dot" />
            <span>Car &amp; counter ordering</span>
          </div>
          <h2 className="display car-title reveal-words">
            Pull up.<br />
            <em>Scan. Order.</em>
          </h2>
        </div>
        <div className="car-header-r">
          <p className="lede reveal">
            QR codes work just as well on a dashboard sticker, a counter card, or a
            drive-through display. The key difference: every scan opens a completely
            isolated session — no shared carts, no crossed orders, ever.
          </p>
          <div className="car-stats reveal">
            <div className="car-stat">
              <span className="car-stat-num">1<em>:1</em></span>
              <span className="car-stat-label">scan to session</span>
            </div>
            <div className="car-stat">
              <span className="car-stat-num">0</span>
              <span className="car-stat-label">shared carts</span>
            </div>
            <div className="car-stat">
              <span className="car-stat-num">∞</span>
              <span className="car-stat-label">concurrent sessions</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main stage */}
      <div className="car-stage reveal">

        {/* Left: QR mount visual */}
        <div className="car-qr-panel">
          <div className="car-qr-mount">
            <div className="cqm-surface-label">
              <span className="cqm-dot" />
              Bay A-02 · QR Mount
            </div>
            <div className="cqm-sticker">
              <div className="cqm-sticker-top">
                <span className="cqm-scan-label">SCAN TO ORDER</span>
                <span className="cqm-brand">PLATEERA</span>
              </div>
              <div className="cqm-qr-wrap">
                <div className="qr-grid cqm-qr-grid">
                  {Array.from({ length: 49 }, (_, i) => (
                    <span key={i} data-on={CAR_QR[i] ? '1' : undefined} />
                  ))}
                </div>
                <div className="cqm-beam" aria-hidden="true" />
              </div>
              <p className="cqm-url">plateera.com/order</p>
            </div>
            <div className="cqm-session-badge">
              <span className="cqm-sess-pulse" />
              New session opened
            </div>
          </div>
          <div className="car-qr-caption">
            Sticker · card · kiosk · any surface
          </div>
        </div>

        {/* Right: session isolation board */}
        <div className="car-sessions-board">
          <div className="csb-head">
            <div className="csb-head-l">
              <span className="csb-live-dot" />
              <span className="csb-title">Isolated Sessions</span>
            </div>
            <span className="csb-count">3 active</span>
          </div>

          {SESSIONS.map((s, i) => (
            <div
              className={`csb-card csb-card--${s.status}`}
              key={s.id}
              style={{ '--i': i }}
            >
              <div className="csb-card-top">
                <span className="csb-session-id">{s.id}</span>
                <span className={`csb-status csb-status--${s.status}`}>
                  {s.status === 'new' ? '● New' : s.status === 'ordering' ? '◎ Ordering' : '✓ Ready'}
                </span>
                <span className="csb-spot">{s.spot}</span>
              </div>
              <div className="csb-items">
                {s.items.map(item => <span key={item}>{item}</span>)}
              </div>
              <div className="csb-card-foot">
                <span className="csb-isolated">
                  <span className="csb-iso-icon">⊘</span> Isolated
                </span>
                <span className="csb-total">{s.total}</span>
              </div>
            </div>
          ))}

          <div className="csb-next-scan">
            <span className="csb-next-pulse" />
            <span>Next scan opens a fresh session →</span>
          </div>
        </div>
      </div>

      {/* Feature caps */}
      <div className="car-caps">
        {CAPS.map((c, i) => (
          <div className="car-cap" key={c.title}>
            <div className="car-cap-icon">{c.icon}</div>
            <h4 className="car-cap-title">{c.title}</h4>
            <p className="car-cap-body">{c.body}</p>
          </div>
        ))}
      </div>

    </section>
  );
}

const CAR_QR = [
  1,1,1,1,1,1,1,
  1,0,0,0,0,0,1,
  1,0,1,0,0,0,1,
  1,0,0,0,1,0,1,
  1,0,1,1,0,0,1,
  1,0,0,0,0,0,1,
  1,1,1,1,1,1,1,
].map(Boolean);
